import { render, staticRenderFns } from "./FamousScholar.vue?vue&type=template&id=e7869f3e&scoped=true&"
import script from "./FamousScholar.vue?vue&type=script&lang=js&"
export * from "./FamousScholar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7869f3e",
  null
  
)

export default component.exports